"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleTextWidget = exports.SwitcherStyles = exports.SelectedToggle = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var FocusIndicators_1 = require("../styles/FocusIndicators");
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var SwitcherTextBase_1 = require("./SwitcherTextBase");
var SelectedToggle;
(function (SelectedToggle) {
    SelectedToggle[SelectedToggle["Left"] = 0] = "Left";
    SelectedToggle[SelectedToggle["Right"] = 1] = "Right";
})(SelectedToggle = exports.SelectedToggle || (exports.SelectedToggle = {}));
exports.SwitcherStyles = {
    container: {
        display: 'flex'
    },
    toggleBase: tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { alignItems: 'center', backgroundColor: 'transparent', borderStyle: 'solid', borderWidth: 1, boxSizing: 'border-box', color: '#2E2E2E', display: 'flex', flexBasis: '100%', justifyContent: 'center', letterSpacing: '0.2px', minHeight: 22, padding: "4px 12px", textAlign: 'center' }),
    firstToggle: {
        borderBottomLeftRadius: 2,
        borderTopLeftRadius: 2,
    },
    lastToggle: {
        borderBottomRightRadius: 2,
        borderTopRightRadius: 2,
    },
    focusToggle: FocusIndicators_1.DefaultFocusIndicator({ inset: true }),
    selectedToggle: {
        backgroundColor: '#05628A',
        borderColor: '#05628A',
        color: '#EAF5FE',
        fontWeight: 'bold',
    },
    hoverSelectedToggle: {
        backgroundColor: '#023248',
        borderColor: '#023248', // component/background/cta/on-light/hover
    },
    activeSelectedToggle: {
        backgroundColor: '#001A28',
        borderColor: '#001A28',
        color: '#EAF5FE', // component/content/cta/on-light/default
    },
    disabledSelectedToggle: {
        backgroundColor: 'transparent',
        borderColor: '#C9C9C9',
        color: '#C9C9C9', // component/content/outline/on-light/disabled
    },
    unselectedToggle: {
        borderColor: '#747474', // component/border/outline/on-light/default
    },
    hoverUnselectedToggle: {
        backgroundColor: '#C9C9C9', // component/background/outline/on-light/hover
    },
    activeUnselectedToggle: {
        backgroundColor: '#AEAEAE', // component/background/outline/on-light/press
    },
    disabledUnselectedToggle: {
        backgroundColor: 'transparent',
        borderColor: '#C9C9C9',
        color: '#C9C9C9', // component/content/outline/on-light/disabled
    },
};
var ToggleTextWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ToggleTextWidget, _super);
    function ToggleTextWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (idx) {
            var _a, _b, _c, _d;
            if (idx === 1) {
                (_b = (_a = _this.props).handleRightToggleSelected) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            else {
                (_d = (_c = _this.props).handleLeftToggleSelected) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
        };
        return _this;
    }
    ToggleTextWidget.prototype.render = function () {
        return (React.createElement(SwitcherTextBase_1.SwitcherTextBase, { ariaLabel: this.props.ariaLabel, className: this.props.className, checkedIndex: this.props.selectedToggle === SelectedToggle.Right ? 1 : 0, disabled: this.props.disabled, handleChange: this.handleChange, name: this.props.name, style: tslib_1.__assign(tslib_1.__assign({}, exports.SwitcherStyles), { container: tslib_1.__assign(tslib_1.__assign({}, exports.SwitcherStyles.container), this.props.containerStyle) }), testId: this.props.testId, toggleTexts: [this.props.leftToggleText, this.props.rightToggleText] }));
    };
    return ToggleTextWidget;
}(React.PureComponent));
exports.ToggleTextWidget = ToggleTextWidget;
//# sourceMappingURL=ToggleTextWidget.js.map